import React, { useState } from 'react';
import ReCAPTCHA from "react-google-recaptcha";

import 'bootstrap/dist/css/bootstrap.min.css';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Ilustracja1 from './images/ilustraja1.webp';
import Ilustracja2 from './images/ilustraja2.webp';
import Call from './images/icons/call.webp';
import Phone from './images/icons/phone.webp';
import Mail from './images/icons/email.webp';
import Klepsy from './images/icons/hourglass.webp';
import Bulb from './images/icons/bulb.webp';
import Heart from './images/icons/serduszko.webp';
import Waiting from './images/Waiting.webp';
import Schemat from './images/schematKompensacji.webp';
import Faktura1 from './images/Energia.webp';
import Faktura2 from './images/Energia2.webp';
import Montaz1 from './images/mont2.webp';
import Montaz2 from './images/mont3.webp';
import Montaz3 from './images/mont4.webp';
import Montaz4 from './images/mont5.webp';
import Arrow from './images/icons/arrow.webp';
import Header from './header.js';
import './App.css';


function Flexik() {
  return (
    <>
      <div className='flexik'>
        <a href='#Start'><img src={Arrow} alt="Arrow to back to the start" /></a>
      </div>
    </>
  );
}

function Hero() {
  return (
    <main className='MainHero'>
      <Header />
      <div className='TextHero'>
        <h1>Płacisz za prąd, którego nie zużywasz?</h1>
        <h2>Sprawdź jak to zmienić!</h2>
        <a href='#Kompensacja'><button>Dowiedz się więcej &#8594; </button></a>
      </div>
    </main>
  );
}

function What() {
  return (
    <>
      <Row className='Reasons What justify-content-center'>
        <Col lg={7} md={12} xs={12} >
          <div className='ResText'>
            <h2>Czym jest moc bierna?</h2>
            <p>Moc bierna to składnik energii elektrycznej, który nie jest zużywany bezpośrednio do zasilania urządzeń, ale jest niezbędny do ich prawidłowego działania. Moc bierna występuje wszędzie tam, gdzie działają urządzenia z elementami indukcyjnymi (np. cewki) lub pojemnościowymi (np. kondensatory).</p>
            <p>Choć sama moc bierna nie wykonuje użytecznej pracy, jej obecność wpływa na obciążenie sieci i może generować dodatkowe koszty. Dlatego tak ważne jest jej monitorowanie i kompensacja, niezależnie od wielkości firmy.</p>
          </div>
        </Col>
      </Row>
    </>
  );
}

function About() {
  return (
    <>
      <article className='About' id="About">
        <Row className='AboutRow'>
          <Col lg={7} md={6} xs={12} className='AboutPhoto'>
            <img src={Ilustracja1} alt='oszczedzanie'/>
          </Col>
          <Col lg={5} md={6} xs={12} className='TextAbout'>
            <div>
              <h2>Co to jest kompensacja mocy biernej?</h2>
              <p>
                Kompensacja mocy biernej pomaga ograniczyć problemy związane z energią, która nie wykonuje pracy, ale obciąża instalację i podnosi koszty. Choć jest potrzebna do działania silników, transformatorów i innych urządzeń, jej nadmiar powoduje straty i wyższe rachunki
              </p>
              <p>
                Stosując odpowiednie urządzenia, można zrównoważyć moc bierną, co pozwala zmniejszyć opłaty za energię i poprawić efektywność działania instalacji. To prosty sposób na oszczędność i stabilniejsze zasilanie.
              </p>
            </div>
          </Col>
        </Row>
      </article>
    </>
  );
}

function Schemacik() {
  return (
    <>
      <section className='SchematPhoto' id="Kompensacja">
        <img src={Schemat} alt='schemat kompensacji biernej'/>
      </section>
    </>
  ); 
}

function Reasons() {
  return (
    <>
      <Row className='Reasons'>
        <Col lg={6} md={12} xs={12}>
          <div className='ResText'>
            <h2>Dlaczego firmy potrzebują kompensacji mocy biernej?</h2>
            <p>Firmy korzystające z energii elektrycznej, niezależnie od wielkości, mogą zmagać się z problemem mocy biernej. Dotyczy to zarówno dużych zakładów przemysłowych, jak i mniejszych działalności, takich jak sklepy osiedlowe, salony fryzjerskie, stacje paliw czy punkty handlowe. Nadmiar mocy biernej prowadzi do wyższych opłat od dostawców energii oraz negatywnie wpływa na efektywność i trwałość urządzeń.</p>
            <p>Skutecznym rozwiązaniem jest kompensacja mocy biernej. Wykorzystanie specjalnych urządzeń do jej zrównoważenia pozwala obniżyć rachunki za prąd, zredukować straty energii i zadbać o lepszą pracę maszyn. To prosty krok do niższych kosztów i większej efektywności energetycznej.</p>
          </div>
        </Col>
        <Col lg={6} md={12} xs={12}>
          <div className='ResText'>
            <h2>Jak działa kompensacja mocy biernej?</h2>
            <p>Kompensacja mocy biernej pozwala ograniczyć nadmiar energii obciążającej instalację. Skutecznym rozwiązaniem są aktywne kompensatory, czyli nowoczesne urządzenia, które automatycznie dopasowują się do warunków panujących w firmie. Oprócz zmniejszenia mocy biernej eliminują również zakłócenia, co poprawia jakość i stabilność zasilania.</p>
            <p>W porównaniu z tradycyjnymi bateriami kondensatorów działają dokładniej i efektywniej, szczególnie w miejscach o zmiennym obciążeniu. Dzięki nim przedsiębiorstwa mogą obniżyć koszty energii, ograniczyć straty i zwiększyć wydajność urządzeń. To nowoczesne rozwiązanie dla firm, które chcą lepiej zarządzać energią.</p>
          </div>
        </Col>
      </Row>
    </>
  );
}

function Advantages() {
  return (
    <>
      <article className='Advantages' id="Advantages">
        <Row className='AdvantagesRow'>
          <Col lg={6} md={6} xs={12} className='TextAdvantages'>
            <div>
              <h2>Jakie korzyści wynikają z kompensacji mocy biernej?</h2>
              <p>
                Kompensacja mocy biernej zapewni waszej instalacji elektrycznej wiele korzyści. Przede wszystkim <b>pozwala obniżyć koszty</b>, eliminując opłaty za nadmiar energii biernej. Dzięki temu przedsiębiorstwa mogą generować <b>realne oszczędności</b>, co ma duże znaczenie przy wysokim zużyciu energii.
              </p>
              <p>
                Dodatkowo <b>poprawia działanie instalacji</b> elektrycznej. Zmniejszenie mocy biernej <b>ogranicza straty energii</b> i <b>zwiększa stabilność pracy urządzeń</b>. W efekcie <b>sprzęt działa dłużej i jest mniej narażony na awarie</b>. To prosty sposób na lepszą efektywność i większą niezawodność systemu zasilania
              </p>
            </div>
          </Col>
          <Col lg={6} md={6} xs={12} className='AboutPhoto'>
            <img src={Ilustracja2} alt='oszczedzanie'/>
          </Col>
        </Row>
      </article>
    </>
  );
}

function Proces() {
  return (
    <>
      <section className='Proces'>
        <Row className='ProcesTexts'>
          <div>
            <h3>Twoja droga do większych oszczędności - zacznij już dziś!</h3>
            <p>Z nami wszystko przebiega jasno i sprawnie. Prosty proces, realne korzyści. Tak właśnie działamy! Zobacz jak: </p>
          </div>
        </Row>
        <Row>
          {/*---Steps---*/}
          <Col lg={3} md={6} xs={12} className='Steps'>
            {/*- Step1 -*/}
            <section className='Step Step1'>
              <div className='StepImage'>
                <img src={Call} alt="Call to us" />
              </div>
              <div className='StepText'>
                <h4>Skontaktuj się z nami</h4>
                <p>Zadzwoń lub wypełnij formularz na stronie. To pierwszy krok do realnych oszczędności. Odpowiemy na Twoje pytania i ustalimy termin analizy </p>
              </div>
            </section>
          </Col>
          {/*- Step2 -*/}
          <Col lg={3} md={6} xs={12} className='Steps'>
            <section className='Step Step2'>
              <div className='StepImage'>
                <img src={Klepsy} alt="Klepsydra" />
              </div>
              <div className='StepText'>
                <h4>Umów się na analizę rachunków</h4>
                <p>Na podstawie danych z rachunków i informacji o instalacji sprawdzimy, czy występuje problem z mocą bierną. W razie potrzeby zaproponujemy dokładny audyt energetyczny, który wskaże, co można poprawić</p>
              </div>
            </section>
          </Col>
          {/*- Step3 -*/}
          <Col lg={3} md={6} xs={12} className='Steps'>
            <section className='Step Step3'>
              <div className='StepImage'>
                <img src={Bulb} alt="Bulb" />
              </div>
              <div className='StepText'>
                <h4>Otrzymaj spresonalizowaną oferte</h4>
                <p>Po analizie lub audycie przygotujemy ofertę dopasowaną do potrzeb Twojej firmy. Po akceptacji zajmiemy się szybkim i fachowym montażem kompensatora</p>
              </div>
            </section>
          </Col>
          {/*- Step4 -*/}
          <Col lg={3} md={6} xs={12} className='Steps'>
            <section className='Step Step4'>
              <div className='StepImage'>
                <img src={Heart} alt="Heart" />
              </div>
              <div className='StepText'>
                <h4>Ciesz się oszczędnościami</h4>
                <p>Po wdrożeniu naszych rozwiązań zobaczysz różnicę, niższe rachunki, stabilna instalacja i większa efektywność. Twoja firma zyskuje czas, pieniądze i energię</p>
              </div>
            </section>
          </Col>
        </Row>
      </section>
    </>
  );
}

function How() {
  return (
    <>
      <Row className='Reasons How justify-content-center'>
        <Col lg={7} md={12} xs={12} >
          <div className='ResText'>
            <h2>Jak dobrać odpowiedni kompensator?</h2>
            <p>Dobór odpowiedniego kompensatora mocy biernej ma bezpośredni wpływ na obniżenie kosztów energii i poprawę pracy całej instalacji elektrycznej. W wielu przypadkach wystarczy analiza faktury za energię elektryczną. Na jej podstawie można wstępnie ocenić poziom poboru mocy biernej i dobrać odpowiednie rozwiązanie. Zdarza się jednak że dane z faktury nie są wystarczające.</p>
            <p>W takich sytuacjach konieczne jest zastosowanie analizatora jakości energii który wykonuje dokładne pomiary i pozwala precyzyjnie dobrać parametry kompensatora.<b> Nasza firma oferuje pełne wsparcie w tym zakresie. Wykonujemy pomiary analizujemy dane i dobieramy rozwiązanie idealnie dopasowane do Twojej instalacji</b>.</p>
            <p>Dzięki temu masz pewność że działasz zgodnie z wymaganiami operatora unikając niepotrzebnych opłat i dbając o trwałość urządzeń</p>
          </div>
        </Col>
      </Row>
    </>
  );
}

function Faktury() {
  return (
    <>
      <section className='Faktury' id="Oferta">
        <Row>
          <Col>
            <p>Tak wygląda różnica przed i po zamontowaniu aktywnych kompensatorów mocy biernej!</p>
          </Col>
        </Row>
        <Row className='FakturyZdj'>
          <Col lg={6} md={6} xs={12} className='FakturaContent'>
            <div className='div'>
              <img src={Faktura1} alt='faktura przed kompensacją'/>
            </div>
            <p>Koszt za energie bierną <b>przed</b> zamontowaniem kompensatorów: 1775,92 zł</p>
          </Col>
          <Col lg={6} md={6} xs={12} className='FakturaContent'>
            <div className='div'>
              <img src={Faktura2} alt='faktura po kompensacji'/>
            </div>
            <p>Koszt za energie bierną <b>po</b> zamontowaniu kompensatorów: 0,0 zł</p>
          </Col>
        </Row>
      </section>
    </>
  );
}

function Montowanie() {
  return (
    <>
      <Row className='Montaz' id="Motaz">
        <Col lg={3} md={6} sm={12} className='Montowanie'>
          <img src={Montaz1} alt='Montaż kompensatora' />
        </Col>
        <Col lg={3} md={6} sm={12} className='Montowanie'>
          <img src={Montaz2} alt='Montaż kompensatora' />
        </Col>
        <Col lg={3} md={6} sm={12} className='Montowanie'>
          <img src={Montaz3} alt='Montaż kompensatora' />
        </Col>
        <Col lg={3} md={6} sm={12} className='Montowanie'>
          <img src={Montaz4} alt='Montaż kompensatora' />
        </Col>
      </Row>
    </>
  );
}

function Formularz() {
  const [email, setEmail] = useState('');
  const [mess, setMess] = useState('');
  const [capVal, setCapVal] = useState();

  const handleSubmit = async e => {
    e.preventDefault();

    try {
      const response = await fetch("/mail.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ capVal, email, mess }),
      });

      const odp = await response.json();
      
      if (odp.success) {
        alert("Form submitted successfully!");
        setCapVal(null);
      } else {
        alert("reCAPTCHA verification failed. Please try again.");
      }
    } catch (err) {
      console.log(err);
    }
    
  };


  return (
    <>
      <Form className='Formularz' onSubmit={handleSubmit}>
        <div className='Wypelnij'>
          <h5>Skontaktuj się z nami już dziś!</h5>
          <p>Wypełnij krótki formularz, a nasz doradca przygotuje bezpłatną analizę i zaproponuje najlepsze rozwiązanie dla Twojej firmy</p>
        </div>
        <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
          <Form.Label className='Label'>Adres e-mail</Form.Label>
          <Form.Control type="email" placeholder="nazwa@example.com" name='email' value={email} onChange={(e) => setEmail(e.target.value)}/>
        </Form.Group>
        <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
          <Form.Label className='Label'>Wiadomość</Form.Label>
          <Form.Control as="textarea" rows={3} name='mess' value={mess}  onChange={(e) => setMess(e.target.value)}/>
        </Form.Group>
        <ReCAPTCHA
          sitekey="6LezkokrAAAAAJSXqsnoXMliFSASJlABruuFfOhD"
          onChange={(val) => setCapVal(val)}  
        />
        <button className="btn btn-primary" type="submit" name='submit' id="submit" value="Send" disabled={!capVal} /*onClick={handleSubmit}*/>Wyślij</button>
      </Form>
    </>
  );
}

function Footer() {
  return (
    <>
      <footer id="Kontakt">
        <Row className='Cole'>
          <Col lg={6} md={12} xs={12} className='WaitingPhoto'>
            <div>
              <img src={Waiting } alt="We aare waiting for you"/>
            </div>
          </Col>
          <Col lg={6} md={12} xs={12} className='DATA'>
            <article className='ContactData'>
              <Row className='ForRow1'>
                {/*--O firmie--*/}
                <Col lg={7} md={7} xs={12} className='Kontakt'>
                  <h6>Skontaktuj się</h6>
                  <Row className='Phonne'>
                    <Col lg={3} md={2} xs={2}>
                      <img src={Phone} alt='logo'/>
                    </Col>
                    <Col lg={9} md={10} xs={10}>
                      <span>+48 696 009 727</span>
                    </Col>
                  </Row>
                  <Row className='Phonne'>
                    <Col lg={3} md={2} xs={2}>
                      <img src={Mail} alt='logo'/>
                    </Col>
                    <Col lg={9} md={10} xs={10}>
                      <a href="mailto:biuro@orszant.pl"><span>biuro@orszant.pl</span></a>
                    </Col>
                  </Row>
                  {/* <Row className='Phonne'>
                    <Col lg={3} md={2} xs={2}>
                      <img src={Instagram} alt='logo'/>
                    </Col>
                    <Col lg={9} md={10} xs={10}>
                      <a href="https://www.instagram.com/" target='blank'><span>Instagram.com</span></a>
                    </Col>
                  </Row> */}
                </Col>
                <Col lg={5} md={5} xs={12} className='Dane'>
                  <div>
                    <h6>Adres</h6>
                    <p>OrszAnt Energia</p>
                    <p>ul. Ogrodnicza 4D</p>
                    <p>Kaczyce, 43-417</p>
                    <p>NIP:5482735701</p>
                  </div>
                </Col>
              </Row>
            </article>
          </Col>
        </Row>
        <Row className='ForRow2'>
          <Col className='Copyright'>
            <hr/>
            <p>OrszAnt.pl Kompensacja. All rights reserved | Created by <a href='https://pixelpick.pl/' target='blank'>Pixelpick</a></p>
          </Col>
        </Row>
      </footer>
    </>
  );
}

function App() {
  return (
    <>
      <Flexik/>
      <Hero />
      <section className='setter'>
        <What/>
        <About /> 
        <Schemacik/>
        <Reasons />
        <Advantages />
        <How/>
        <Faktury />
        <Montowanie/>
        <Proces />
        <Formularz/>
      </section>
      <Footer/>
    </>
  );
}

export default App;
